import { SvgIcon } from "@mui/material";
import { Icon } from "@mdi/react";

export const RenderIcon = (icon: string) => {
    return (
        <SvgIcon>
            <Icon path={icon} />
        </SvgIcon>
    )
}